var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100.9,
    viewBox: "0 0 88.967 100.9",
    width: 88.967,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.516 -25.893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.613 116.706-8.1-90.813h88.967l-8.1 90.8-36.434 10.1z",
    fill: "#1572b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 119.072 29.44-8.162 6.926-77.591h-36.366z",
    fill: "#33a9dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 66.22h14.738l1.019-11.4h-15.757v-11.143h27.929l-.267 2.988-2.737 30.692h-24.925z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.067 95.146-.049.014-12.4-3.35-.794-8.883h-11.183l1.559 17.488 22.814 6.333.052-.015v-11.587z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.792 76.886-1.342 14.914-12.422 3.355v11.588l22.833-6.328.168-1.882 1.938-21.647z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.039 43.677v11.137h-26.9l-.224-2.5-.507-5.646-.267-2.988h27.9zm-.039 22.544v11.138h-12.247l-.223-2.5-.508-5.647-.267-2.988z",
    fill: "#ebebeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.cb3ea03c70ae23cd6eb241f1a6dddf9e.svg";
export { ForwardRef as ReactComponent };